module.exports = __webpack_public_path__ + "static/media/D98A1759_1x.f2f922ef.jpg";